import { mainCategoryResultSchema } from "@/schema/improvement-proposal/MainCategoryResult";
import { z } from "zod";

export const improvementProposalSchema = z.object({
  id: z.number(),
  corporate_number: z.string().nullable(),
  registration_number: z.string().nullable(),
  main_category_results: z.array(mainCategoryResultSchema),
  updated_at: z.coerce.date(),
});

export type ImprovementProposal = z.infer<typeof improvementProposalSchema>;
